import type { PonteDoCaixa as Ponte } from "@bookdental/schemas";
import { reais } from "@/lib/dinheiro";
import { cn } from "@/lib/cn";
import { moldura } from "../estilos";

const LINHAS: { chave: keyof Ponte; rotulo: string; dica: string }[] = [
  { chave: "semDinheiroCents", rotulo: "(+) Custos sem saída de dinheiro", dica: "Depreciação, provisão de 13º e férias, impostos estimados e material consumido do estoque." },
  { chave: "recebidoMenosFaturadoCents", rotulo: "(±) Recebido dos clientes − faturado", dica: "Negativo: faturou mais do que recebeu (o a receber cresceu)." },
  { chave: "contasCents", rotulo: "(±) Contas lançadas − pagas", dica: "Positivo: despesas do período ainda não pagas; negativo: pagou contas de outros meses." },
  { chave: "soDeCaixaCents", rotulo: "(−) Pagamentos fora da conta do resultado", dica: "Compras de material com o custo pela ficha, 13º e férias provisionados, DARF com o IR estimado." },
  { chave: "foraDoResultadoCents", rotulo: "(±) Retiradas, investimentos e empréstimos", dica: "Movimentos das categorias fora do resultado." },
];

/** "Lucrei X, mas o caixa só mexeu Y": a ponte do resultado (competência) até o caixa do período. */
export function PonteDoCaixa({ ponte }: { ponte: Ponte }) {
  return (
    <section className={cn(moldura, "p-4")}>
      <h3 className="text-sm font-semibold text-zinc-900 dark:text-foreground">Do resultado ao caixa</h3>
      <p className="mt-0.5 text-xs text-zinc-500 dark:text-muted-foreground">Por que o dinheiro em caixa não mexeu o mesmo que o resultado.</p>
      <dl className="mt-3 divide-y divide-zinc-100 text-sm dark:divide-border/50">
        <div className="flex justify-between py-1.5 font-semibold">
          <dt>Resultado</dt>
          <dd className="tabular-nums">{reais(ponte.resultadoCents)}</dd>
        </div>
        {LINHAS.filter((l) => ponte[l.chave]).map((l) => (
          <div key={l.chave} className="flex justify-between gap-3 py-1.5">
            <dt className="min-w-0 text-zinc-700 dark:text-foreground/80">
              {l.rotulo}
              <span className="block text-[11px] text-zinc-500 dark:text-muted-foreground">{l.dica}</span>
            </dt>
            <dd className="shrink-0 tabular-nums text-zinc-900 dark:text-foreground">{reais(ponte[l.chave])}</dd>
          </div>
        ))}
        <div className="flex justify-between py-1.5 font-semibold">
          <dt>= Variação do caixa</dt>
          <dd className={cn("tabular-nums", ponte.variacaoDoCaixaCents >= 0 ? "text-emerald-600" : "text-red-600")}>{reais(ponte.variacaoDoCaixaCents)}</dd>
        </div>
      </dl>
    </section>
  );
}
